module.exports = __webpack_public_path__ + "static/media/photo-11.7b6c42e5.jpg";